import type { ISchedule } from '@/interfaces'

export class Schedule implements ISchedule {
	milestone: string
	milestoneDate?: Date | null

	constructor({ milestone, milestoneDate }: ISchedule) {
		this.milestone = milestone
		this.milestoneDate = milestoneDate
	}
}
